import { ItemType } from '@vendasta/marketplace-apps';
import { InventoryItem } from '../../common/inventory-item';
import { ItemSelectorRowItem, SelectedItem } from '../interface';

export function findItem(items: SelectedItem[], itemId: string): [SelectedItem | null, number] {
  const index = items?.findIndex((selectedItem) => {
    return selectedItem.itemId === itemId;
  });
  if (index >= 0) {
    return [items[index], index];
  }
  return [null, -1];
}

export function convertInventoryItemToSelectedItem(inventoryItem: InventoryItem, immutable = false): SelectedItem {
  return {
    ...inventoryItem,
    immutable: immutable,
  };
}

export function convertRowItemToSelectedItem(rowItem: ItemSelectorRowItem): SelectedItem {
  const name = rowItem.sellerWhitelabelName || rowItem.defaultName;
  const iconUrl = rowItem.sellerWhitelabelIconUrl || rowItem.iconUrl;
  const base: Omit<SelectedItem, 'type'> = {
    itemId: rowItem.itemId,
    name: name ?? '',
    iconUrl: iconUrl ?? '',
    quantity: rowItem.quantity ?? 1,
    immutable: rowItem.immutable,
  };

  if (rowItem.itemType === ItemType.ITEM_TYPE_PACKAGE) {
    return {
      ...base,
      type: 'package',
    };
  }

  if (rowItem.itemType === ItemType.ITEM_TYPE_ADDON) {
    return {
      ...base,
      type: 'addon',
      parentItemId: rowItem?.requiredItems?.[0].itemId ?? '',
    };
  }

  const rowEdition = rowItem?.editions?.find((edition) => edition.editionId === rowItem.editionId);
  return {
    ...base,
    type: 'app',
    edition: {
      editionId: rowEdition?.editionId ?? '',
      name: rowEdition?.name ?? '',
    },
  };
}

export function mapify<I, V>(array: I[], keyFn: (item: I) => string, valueFn: (item: I) => V): Map<string, V> {
  return array.reduce((map, item) => {
    map.set(keyFn(item), valueFn ? valueFn(item) : item);
    return map;
  }, new Map());
}
